import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { reverse, forEach, map, join, filter } from 'lodash';
import MobileLineItem from './MobileLineItem';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';

class MobileLineList extends Component {
    constructor() {
        super();
    };
    virtualNumberNaming(type) {
        const { translate } = this.props;
        let label = type ? 'virtual-number' : 'secondary-numbers';
        return translate(label);
    }

    /**
     * @param secondaryNumbers
     * @returns {string}
     */
    showOtherNumbers(secondaryNumbers) {
        if (!Array.isArray(secondaryNumbers)) {
            secondaryNumbers = [secondaryNumbers]
        }
        let filteredNumbers = filter(secondaryNumbers, (el) => {
            return el != null;
        });
        return join(map(filteredNumbers, (element) => {
            return PhoneNumberFormat(element)
        }), " - ")
    }
    render() {
        const { translate, mobileLines } = this.props
        if (mobileLines.length > 0) {
            let list = []
            forEach(mobileLines, (product) => {
                let pendingUpgradeInformations = '';
                if (product.Data.pendingUpgradeInformation) {
                    let pendingUpgradeDate = product.Data.pendingUpgradeInformation.upgrade_date;
                    let pendingUpgradeProductName = product.Data.pendingUpgradeInformation.upgrade_product_name;
                    pendingUpgradeInformations = translate('upgrade-update-on') + pendingUpgradeDate + translate('upgrade-to') + pendingUpgradeProductName
                }
                list.push(
                    <MobileLineItem
                        Data={product.Data}
                        bundleName={product.Data.bundleName}
                        isInBundle={product.Data.isInBundle}
                        isFrozen={product.Data.isFrozen}
                        hasFutureFreeze={product.Data.hasFutureFreeze}
                        futureFreezeStartingDate={product.Data.futureFreezeStartingDate}
                        currentFreezeEndDate={product.Data.currentFreezeEndDate}
                        forwardData={product.Data.forwardData}
                        isActive={product.Data.isActive}
                        userProductId={product.Data.userProductId}
                        offer={product.Data.offer}
                        title={PhoneNumberFormat(product.Data.phoneNumber)}
                        subscription1={translate('current-offer')}
                        subtitle1={product.Data.offer}
                        subscription2={this.virtualNumberNaming(product.Data.hasMissedCalls)}
                        subtitle2={this.showOtherNumbers(product.Data.virtualPhoneNumber || product.Data.secondaryPhoneNumbers)}
                        createdDate={product.Data.createdDate}
                        simNumber={product.Data.simNumber}
                        provider={product.Data.provider}
                        options={product.Options}
                        key={product.Data.userProductId}
                        virtualPhoneNumber={this.showOtherNumbers(product.Data.virtualPhoneNumber)}
                        hasFutureMispari={product.Data.hasFutureMispari}
                        hasMispariActive={product.Data.hasMispariActive}
                        isPendingActivation={product.Data.isPendingActivation}
                        hasPendingUpgrade={product.Data.hasPendingUpgrade}
                        pendingUpgradeInformations={pendingUpgradeInformations}
                        hasOngoingTransfer={product.Data.hasOngoingTransfer}
                        activationLink={product.Data.activationLink}
                        pendingMigrationInformation={product.Data.pendingMigrationInformation}
                        canActivateMispari={product.Data.canActivateMispari}
                        hasApnFilter={product.Data.hasApnFilter}
                        showOptions={product.Data.showOptions}
                        cantBeDisplayInInactiveLines={product.Data.cantBeDisplayInInactiveLines}
                        balance={product.Data.balance}
                        isEsim={product.Data.isEsim}
                        statusEsim={product.Data.statusEsim}
                        lastIccidImei={product.Data.lastIccidImei}
                    />)
            }
            )
            return list
        } else {
            return null;
        }
    }
}
const mapStateToProps = (state) => {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

MobileLineList = connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileLineList);
export default MobileLineList;



// WEBPACK FOOTER //
// ./src/components/MyServices/MobileLineList.js